import * as chrono from 'chrono-node'
import dayjs from 'dayjs'

const supportedFormats = [
  // Date formats
  'YYYY-MM-DD', // 2023-05-03
  'YYYY/MM/DD', // 2023/05/03
  'DD/MM/YYYY', // 03/05/2023
  'DD-MM-YYYY', // 03-05-2023
  'MM/DD/YYYY', // 05/03/2023 (US format)
  'YYYY.MM.DD', // 2023.05.03
  'DD.MM.YYYY', // 03.05.2023
  'YYYYMMDD', // 20230515 (compact format)

  'YYYY-MM-D', // 2023-05-3
  'YYYY/MM/D', // 2023/05/3
  'D/MM/YYYY', // 3/05/2023
  'D-MM-YYYY', // 3-05-2023
  'MM/D/YYYY', // 05/3/2023 (US format)
  'YYYY.MM.D', // 2023.05.3
  'D.MM.YYYY', // 3.05.2023
  'YYYYMMD', // 20230515 (compact format)

  'DD MMM YYYY', // 02 May 2023
  'DD MMMM YYYY', // 02 May 2023
  'MMMM DD, YYYY', // May 15, 2023
  'MMM DD, YYYY', // May 15, 2023

  'D MMM YYYY', // 2 May 2023
  'D MMMM YYYY', // 2 May 2023
  'MMMM D, YYYY', // May 15, 2023
  'MMM D, YYYY', // May 15, 2023

  // Date and time formats
  'YYYY-MM-DD HH:mm', // 2023-05-15 09:30
  'YYYY/MM/DD HH:mm', // 2023/05/15 09:30
  'DD/MM/YYYY HH:mm', // 15/05/2023 09:30
  'DD-MM-YYYY HH:mm', // 15-05-2023 09:30
  'YYYY-MM-DD HH:mm:ss', // 2023-05-15 09:30:00
  'YYYY/MM/DD HH:mm:ss', // 2023/05/15 09:30:00
  'DD/MM/YYYY HH:mm:ss', // 15/05/2023 09:30:00
  'DD-MM-YYYY HH:mm:ss', // 15-05-2023 09:30:00

  // Date and time formats with AM/PM
  'YYYY-MM-DD hh:mm A', // 2023-05-15 09:30 AM
  'DD/MM/YYYY hh:mm A', // 15/05/2023 09:30 AM
  'MMMM DD, YYYY hh:mm A', // May 15, 2023 09:30 AM

  // ISO 8601 formats
  'YYYY-MM-DDTHH:mm:ssZ', // 2023-05-15T09:30:00Z
  'YYYY-MM-DDTHH:mm:ss.SSSZ', // 2023-05-15T09:30:00.000Z

  // Formats with day of week
  'ddd, DD MMM YYYY', // Mon, 15 May 2023
  'dddd, MMMM DD, YYYY', // Monday, May 15, 2023

  // Formats with short year
  'YY-MM-DD', // 23-05-15
  'DD/MM/YY', // 15/05/23
  'DD MMM YY', // 15 May 23

  // Time-only formats
  'HH:mm:ss', // 09:30:00
  'HH:mm', // 09:30
  'hh:mm A', // 09:30 AM

  // ISO week formats
  'YYYY-[W]WW', // 2023-W20
  'YYYY-[W]WW-E', // 2023-W20-1

  // Year formats
  'YY', // 01
  'YYYY', // 2001

  // Month formats
  'M', // 1-12
  'MM', // 01-12
  'MMM', // Jan-Dec
  'MMMM', // January-December

  // Day formats
  'D', // 1-31
  'DD', // 01-31

  // Hour formats
  'H', // 0-23
  'HH', // 00-23
  'h', // 1-12
  'hh', // 01-12

  // Minute formats
  'm', // 0-59
  'mm', // 00-59

  // Second formats
  's', // 0-59
  'ss', // 00-59

  // Combinations
  'YYYY-M-D', // 2001-1-1
  'YYYY-MM-DD', // 2001-01-01
  'YYYY-MMM-DD', // 2001-Jan-01
  'YYYY-MMMM-DD', // 2001-January-01
  'YY-M-D', // 01-1-1
  'YY-MM-DD', // 01-01-01
  'YY-MMM-DD', // 01-Jan-01
  'YY-MMMM-DD', // 01-January-01
  'M/D/YYYY', // 1/1/2001
  'MM/DD/YYYY', // 01/01/2001
  'MMM D YYYY', // Jan 1 2001
  'MMMM D YYYY', // January 1 2001
  'M/D/YY', // 1/1/01
  'MM/DD/YY', // 01/01/01
  'MMM D YY', // Jan 1 01
  'MMMM D YY', // January 1 01
  'D M YYYY', // 1 1 2004
  'DD M YYYY', // 01 1 2004
  'D MM YYYY', // 1 01 2004

  // Date and time combinations
  'YYYY-M-D H:m', // 2001-1-1 0:0
  'YYYY-M-D H:m:s', // 2001-1-1 0:0:0
  'YYYY-M-D HH:mm', // 2001-1-1 00:00
  'YYYY-M-D HH:mm:ss', // 2001-1-1 00:00:00
  'YYYY-M-D h:m A', // 2001-1-1 12:0 AM
  'YYYY-M-D h:m:s A', // 2001-1-1 12:0:0 AM
  'YYYY-M-D hh:mm A', // 2001-1-1 12:00 AM
  'YYYY-M-D hh:mm:ss A', // 2001-1-1 12:00:00 AM
  'M/D/YYYY H:m', // 1/1/2001 0:0
  'M/D/YYYY H:m:s', // 1/1/2001 0:0:0
  'M/D/YYYY HH:mm', // 1/1/2001 00:00
  'M/D/YYYY HH:mm:ss', // 1/1/2001 00:00:00
  'M/D/YYYY h:m A', // 1/1/2001 12:0 AM
  'M/D/YYYY h:m:s A', // 1/1/2001 12:0:0 AM
  'M/D/YYYY hh:mm A', // 1/1/2001 12:00 AM
  'M/D/YYYY hh:mm:ss A', // 1/1/2001 12:00:00 AM
  'MMM D YYYY H:m', // Jan 1 2001 0:0
  'MMM D YYYY H:m:s', // Jan 1 2001 0:0:0
  'MMM D YYYY HH:mm', // Jan 1 2001 00:00
  'MMM D YYYY HH:mm:ss', // Jan 1 2001 00:00:00
  'MMM D YYYY h:m A', // Jan 1 2001 12:0 AM
  'MMM D YYYY h:m:s A', // Jan 1 2001 12:0:0 AM
  'MMM D YYYY hh:mm A', // Jan 1 2001 12:00 AM
  'MMM D YYYY hh:mm:ss A', // Jan 1 2001 12:00:00 AM
  'MMMM D YYYY H:m', // January 1 2001 0:0
  'MMMM D YYYY H:m:s', // January 1 2001 0:0:0
  'MMMM D YYYY HH:mm', // January 1 2001 00:00
  'MMMM D YYYY HH:mm:ss', // January 1 2001 00:00:00
  'MMMM D YYYY h:m A', // January 1 2001 12:0 AM
  'MMMM D YYYY h:m:s A', // January 1 2001 12:0:0 AM
  'MMMM D YYYY hh:mm A', // January 1 2001 12:00 AM
  'MMMM D YYYY hh:mm:ss A', // January 1 2001 12:00:00 AM
]

/**
 * Helper function to parse date input in any format into dayjs supported format,
 * this currently being implemented in GridV2
 *
 * @todo handle locale
 */
export function parseDateInput(dateInput: string) {
  // try use chrono parser by default, see https://www.npmjs.com/package/chrono-node
  const parsed = dayjs(chrono.parseDate(dateInput))

  if (parsed.isValid()) {
    return parsed
  }

  // use custom parser
  let result = null
  for (const format of supportedFormats) {
    const date = dayjs(dateInput, format)
    if (date.isValid()) {
      result = date
      break
    }
  }
  return result
}
